export const KEYS = {
  KEY_BACKSPACE: 'Backspace',
  KEY_DELETE: 'Delete',
  KEY_ENTER: 'Enter',
  KEY_TAB: 'Tab',
};
